"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RETRY_COUNTS = exports.DEFAULT_SEND_MESSAGE_TIMEOUT = void 0;
/**
 * 默认发送消息超时时间
 */
var DEFAULT_SEND_MESSAGE_TIMEOUT = 25000;
exports.DEFAULT_SEND_MESSAGE_TIMEOUT = DEFAULT_SEND_MESSAGE_TIMEOUT;
/**
 * 默认重试次数
 */
var DEFAULT_RETRY_COUNTS = 3;
exports.DEFAULT_RETRY_COUNTS = DEFAULT_RETRY_COUNTS;
